import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from './formly-builder.models';
import { LuFormlyInputBuilder } from './input.builder';

export class LuFormlyTextAreaBuilder extends LuFormlyInputBuilder {
	protected type = FieldType.TEXT_AREA;
	private rows: number;

	public setRows(rows: number): this {
		this.rows = rows;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.rows = this.rows;

		return field;
	}
}
